
const APP_PATHS = {
  HOME: '/',
  POST_JOB: '/create',
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/reset-password',
  JOBS: '/jobs',
  PRICING: '/#pricing',
  MANAGE_RECRUITERS: '/manage/recruiters',
  MANAGE_JOBS: '/manage/jobs',
  CONTACT_US: `/contact-us`,
  TERMS_OF_USE: `/terms-of-use`,
  PRIVACY_POLICY: `/privacy-policy`,
  REFUND_CANCELLATION_POLICY: `/refund-cancellation-policy`,
  TESTIMONIALS: '#testimonials',
  FAQS: '/#faq',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  WELCOME: '/welcome',
  PROFILE: '/profile',
  EDIT_PROFILE: '/profile/edit',
  ACCOUNT_SETTINGS: '/profile/settings',
  BOOKMARK: '/profile/bookmarks',
  PROJECTS: '/profile/projects',
  RESUME: '/profile/resume',
  EXPERIENCE: '/profile/experience',
  SKILLS: '/profile/skills',
};
export default APP_PATHS;
